"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitterTags = void 0;
const react_1 = __importDefault(require("react"));
const constants_1 = require("./constants");
const types_1 = require("./types");
const TwitterTags = ({ androidAppUrl, description, imageUrl, iosAppUrl, title = "Eventbrite", twitterCard = types_1.TwitterCard.Summary, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("meta", { name: "twitter:card", content: twitterCard }),
    react_1.default.createElement("meta", { name: "twitter:site", content: "@eventbrite" }),
    react_1.default.createElement("meta", { name: "twitter:title", content: title }),
    description && react_1.default.createElement("meta", { name: "twitter:description", content: description }),
    react_1.default.createElement("meta", { name: "twitter:image", content: imageUrl ? imageUrl : constants_1.OPEN_GRAPH_DEFAULT_IMAGE_PATH }),
    react_1.default.createElement("meta", { name: "twitter:app:name:iphone", content: "Eventbrite" }),
    iosAppUrl && react_1.default.createElement("meta", { name: "twitter:app:url:iphone", content: iosAppUrl }),
    react_1.default.createElement("meta", { name: "twitter:app:id:iphone", content: "487922291" }),
    react_1.default.createElement("meta", { name: "twitter:app:name:googleplay", content: "Eventbrite" }),
    androidAppUrl && react_1.default.createElement("meta", { name: "twitter:app:url:googleplay", content: androidAppUrl }),
    react_1.default.createElement("meta", { name: "twitter:app:id:googleplay", content: "com.eventbrite.attendee" })));
exports.TwitterTags = TwitterTags;
//# sourceMappingURL=TwitterTags.js.map